import { render } from "./RequestMaterial.vue?vue&type=template&id=e639beb8&scoped=true"
import script from "./RequestMaterial.vue?vue&type=script&lang=js"
export * from "./RequestMaterial.vue?vue&type=script&lang=js"

import "./RequestMaterial.vue?vue&type=style&index=0&id=e639beb8&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e639beb8"]])

export default __exports__